import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Table, Zone } from '@app/shared/models';
import { TableService } from '@app/shared/services';
import * as QRCode from 'qrcode';

@Component({
  selector: 'app-table-config',
  templateUrl: './table-config.component.html',
  styleUrls: ['./table-config.component.scss']
})
export class TableConfigComponent implements OnInit, OnChanges {
  @Input() table: Table | null = null;
  @Input() mode: 'create' | 'edit' = 'create';
  @Input() selectedZoneId: string | null = null;
  @Output() saved = new EventEmitter<Table>();
  @Output() cancelled = new EventEmitter<void>();

  form!: FormGroup;
  zones: Zone[] = [];
  /** Data URL del QR para compartir (solo en modo edición). */
  qrDataUrl: string | null = null;
  tableStatusUrl = '';

  constructor(
    private formBuilder: FormBuilder,
    private tableService: TableService
  ) { }

  ngOnInit(): void {
    this.zones = this.tableService.getZones();
    this.initializeForm();
    this.updateQrIfEdit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['table'] || changes['mode']) {
      this.updateQrIfEdit();
    }
  }

  private updateQrIfEdit(): void {
    if (this.mode !== 'edit' || !this.table?.accessCode) {
      this.qrDataUrl = null;
      this.tableStatusUrl = '';
      return;
    }
    this.tableStatusUrl = this.getTableStatusUrl();
    QRCode.toDataURL(this.tableStatusUrl, { width: 220, margin: 1 }).then(
      (dataUrl) => { this.qrDataUrl = dataUrl; },
      () => { this.qrDataUrl = null; }
    );
  }

  /** URL pública para ver estado de la mesa (solo funciona si hay pedido activo no facturado). */
  getTableStatusUrl(): string {
    if (!this.table?.accessCode) return '';
    const base = document.querySelector('base')?.getAttribute('href') || '/';
    const path = base.replace(/\/$/, '') + '/p/table-status';
    return window.location.origin + path + '?code=' + encodeURIComponent(this.table.accessCode);
  }

  private initializeForm(): void {
    const table = this.table;
    this.form = this.formBuilder.group({
      number: [table?.number || '', [Validators.required, Validators.min(1)]],
      capacity: [table?.capacity || 4, [Validators.required, Validators.min(1), Validators.max(20)]],
      zoneId: [table?.zoneId || this.selectedZoneId || '', Validators.required],
      positionX: [table?.positionX || 0],
      positionY: [table?.positionY || 0],
    });
  }

  onSave(): void {
    if (!this.form.valid) {
      alert('Por favor completa todos los campos requeridos');
      return;
    }

    const formValue = this.form.value;

    if (this.mode === 'create') {
      const newTable = new Table(
        `table_${Date.now()}`,
        formValue.number,
        formValue.capacity,
        formValue.zoneId,
        formValue.positionX,
        formValue.positionY
      );
      this.saved.emit(newTable);
    } else if (this.table) {
      this.table.number = formValue.number;
      this.table.capacity = formValue.capacity;
      this.table.zoneId = formValue.zoneId;
      this.table.positionX = formValue.positionX;
      this.table.positionY = formValue.positionY;
      this.saved.emit(this.table);
    }
  }

  onCancel(): void {
    this.cancelled.emit();
  }

  getTitle(): string {
    return this.mode === 'create' ? 'Crear Nueva Mesa' : 'Editar Mesa';
  }
}
